import React from "react";
import { Bar } from "react-chartjs-2";
import { CardBody } from "reactstrap";

function MonthlyBooking({barChartData, chartOptions}) {
  const data = {
    labels: barChartData.map(item => item.period),
    datasets: [
      {
        label: 'Bookings',
        data: barChartData.map(item => item.bookings),
        backgroundColor: '#556ee6',
        borderColor: '#556ee6',
        borderWidth: 1
      },
      {
        label: 'Revenue',
        data: barChartData.map(item => Number(item.totalAmount)),
        backgroundColor: '#34c38f',
        borderColor: '#34c38f',
        borderWidth: 1,
        yAxisID: 'revenue'
      }
    ]
  };

  const options = {
    ...chartOptions,
    scales: {
      ...chartOptions.scales,
      revenue: {
        type: 'linear',
        position: 'right',
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          callback: function(value) {
            return '$' + value.toLocaleString();
          }
        }
      }
    }
  };

  return (
    <CardBody>
      <div className="d-flex align-items-center mb-3">
        <h4 className="card-title flex-grow-1 mb-0">Bookings & Revenue</h4>
      </div>
      <div style={{ height: "320px" }}>
        <Bar data={data} options={options} />
      </div>
    </CardBody>
  );
}
 
export default MonthlyBooking;
